import {Component, Vue, Prop} from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import PerformanceProgress from '@/components/charts/performance-bar/performance-bar';
import DountChart from '@/components/charts/dount-chart/dount-chart';
import FontAwesomeIcon from '@/components/icons/font-awesome-icon/font-awesome-icon';
import { numberFormatWithTextSuffix } from '@/helpers/number-format';
import { UsersData, UsersDrilldown } from '@/models/groups/users';
import { appConfigService } from '@/providers/services/app/app-config';
import { SubjectModel } from '@/models/groups/subjects';
import { sortByProperty } from '@/utils/utils';
import { DEMO_HIERARCHY_POPUP_HEADS } from '@/utils/constants';

@Component({
    name: 'new-user-popup',
    components: {
        'material-icon': GoogleMaterialIcon,
        'performance-bar': PerformanceProgress,
        'dount-chart': DountChart,
        'font-awesome': FontAwesomeIcon,
    },
})

export default class NewUserPopup extends Vue {


    private get drilldownData() {
        const drilldown = this.usersDrillDownData  ? this.usersDrillDownData.drilldown : [];
        sortByProperty(drilldown, 'totalStudents', 'DESC');
        return drilldown;
    }

    private get totalTeachers() {
        return this.drilldownData.reduce((a: number, b: UsersDrilldown) => a + b.totalTeachers, 0);
    }

    private get totalStudents() {
        return this.drilldownData.reduce((a: number, b: UsersDrilldown) => a + b.totalStudents, 0);
    }

    private get maxTeacherCount() {
        return this.drilldownData.reduce(
            (a: number, b: UsersDrilldown) => a = a > b.totalTeachers ? a : b.totalTeachers, 0);
    }

    private get maxStudentCount() {
        return this.drilldownData.reduce(
            (a: number, b: UsersDrilldown) => a = a > b.totalStudents ? a : b.totalStudents, 0);
    }

    get groupLabel() {
        const accessibleLevels = appConfigService.getUserGroupAccessLevel();
        const competencyData: any = this.groupType === 'class' ? null : this.usersDrillDownData;
        const activeLevelIndex = accessibleLevels.findIndex((level: any) => level.type === competencyData.type);
        if (this.$access.isDemoGroup) {
            return this.groupType === 'class'
                ? 'student' : DEMO_HIERARCHY_POPUP_HEADS[accessibleLevels[activeLevelIndex + 1].type];
        }
        return this.groupType === 'class' ? 'student' : activeLevelIndex >= 0 ? accessibleLevels[activeLevelIndex + 1] ?
        accessibleLevels[activeLevelIndex + 1].name : competencyData.type : competencyData.type;
    }

    get chartData() {
        return [{
            name: 'chart',
            value: this.totalStudents || 0,
            color: '#fd7e14',
        },
        {
            name: 'chart1',
            value: this.totalTeachers || 0,
            color: '#000',
        },
        ];
    }

    @Prop()
    private cardValue!: string;

    @Prop()
    private currentMonth: any;

    @Prop()
    private activeYear: any;


    private get level() {
        return this.drilldownData[0].type;
    }

    private get countryName() {
        return this.$route.params.name;
    }

    @Prop()
    private usersDrillDownData!: UsersData;

    @Prop()
    private groupType!: string;

    @Prop({default: false})
    private isRestrictClass!: boolean;

    @Prop()
    private isAtInitialLevel!: boolean;

    @Prop()
    private subjectList!: SubjectModel[];

    @Prop()
    private activeSubject: any;

    private get disablePullup() {
        return this.groupType === 'class';
    }


    private get isDemoTenant() {
        return appConfigService.isDemoTenant();
    }

    private get subSelection() {
        return this.$access.isDemoGroup
            ? DEMO_HIERARCHY_POPUP_HEADS[this.usersDrillDownData.type]
            : this.usersDrillDownData.name;
    }

    // -----------------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$emit('onGoBack', false);
    }

    private onSelectLevel(level: any) {
        this.$emit('onSelectLevel', level);
    }

    private onGoUpward() {
        this.$emit('onGoUpward');
    }

    private onSelectSubject(subject: any) {
        this.$emit('onSelectSubject', subject);
    }

    // ------------------------------------------------------------------------
    // Hooks

    private created() {
         window.scrollTo(0, 0);
    }


    // --------------------------------------------------------------------------
    // Methods


    private numberFormatWithTextSuffix(value: number) {
        return numberFormatWithTextSuffix(value);
    }

    private iconLoader(count: any, type: string = 'teacher') {
        let userCount = type === 'teacher' ? this.maxTeacherCount : this.maxStudentCount;
        userCount = Math.max(0, Math.round((count / userCount) * 7));
        userCount = (!userCount && count) ? 1 : userCount;
        return userCount ? new Array(userCount).fill({}) : [];
    }
}
